import { Text, Title, rem } from "@mantine/core";
import {} from "../components";
type Props = {
  id: string;
};

export default function Introduction({ id }: Props) {
  return (
    <section id={id}>
      <Title sx={{ visibility: "hidden" }}>Introduction</Title>
      <Text
        c="dimmed"
        ta="center"
        mt="md"
        sx={(theme) => ({
          maxWidth: 600,
          margin: "auto",

          "&::after": {
            content: '""',
            display: "block",
            backgroundColor: theme.colors.yellow[4],
            width: rem(45),
            height: rem(2),
            marginTop: theme.spacing.sm,
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: theme.spacing.sm,
          },
        })}
      >
        黃絲傅冷氣，您的一站式冷氣和家居保養專家！我們提供多種服務，讓您的家居或辦公室保持良好狀態
      </Text>
    </section>
  );
}
